import React from 'react';
import { NavLink } from "react-router-dom";
import styles from '../styles/nav.module.css';
import logo from '../images/JS-logo-small.png';

const Header = () => {
    return (
    <nav id="navigation">
        <ul className={styles.navbar}>
          <li>
            <NavLink className={({ isActive }) => isActive ? styles.active : ""} to="/">Home</NavLink>
          </li>
          <li>
            <NavLink className={({ isActive }) => isActive ? styles.active : ""} to="/projects">Projects</NavLink>
          </li>
          <li>
            <img className={styles.logo} src={logo} alt="JS Logo" />
          </li>
          <li>
            <NavLink className={({ isActive }) => isActive ? styles.active : ""} to="/about">About</NavLink>
          </li>
          <li>
            <NavLink className={({ isActive }) => isActive ? styles.active : ""} to="/contact">Contact</NavLink>
          </li>
        </ul>
    </nav>
    )
  };
  
export default Header;